(() => {
 const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
 const SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
 let busy = false;


 async function toggle(button) {
   if (busy) return;
   busy = true;


   const isActive = button.getAttribute('aria-checked') === 'true';
   const variantId = button.dataset.variantId;
   const lineKey = button.dataset.lineKey;
   const card = button.closest('.sp-card');


   if (isActive) {
     sessionStorage.setItem('sp_user_removed', '1');
   } else {
     sessionStorage.removeItem('sp_user_removed');
   }


   button.setAttribute('aria-checked', String(!isActive));
   if (card) card.classList.toggle('sp-card--active', !isActive);


   const url = isActive && lineKey ? `${ROOT}cart/change.js` : `${ROOT}cart/add.js`;
   const body = isActive && lineKey
     ? { id: lineKey, quantity: 0, sections: SECTIONS.join(','), sections_url: window.location.pathname }
     : { items: [{ id: variantId, quantity: 1 }], sections: SECTIONS.join(','), sections_url: window.location.pathname };


   try {
     const res = await fetch(url, {
       method: 'POST',
       headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
       body: JSON.stringify(body),
     });
     if (!res.ok) throw new Error('Cart request failed');
     renderSections((await res.json()).sections);
   } catch (err) {
     console.error('[sp-toggle]', err);
     button.setAttribute('aria-checked', String(isActive));
     if (card) card.classList.toggle('sp-card--active', isActive);
   } finally {
     busy = false;
   }
 }


 async function autoAdd() {
   if (busy) return;
   if (sessionStorage.getItem('sp_user_removed') === '1') return;
   const button = document.querySelector('.sp-toggle');
   if (!button) return;
   if (button.getAttribute('aria-checked') === 'true') return;
   await toggle(button);
 }


 // If the only thing left in the cart is the shipping protection,
 // silently remove it so the cart becomes truly empty.
 async function removeProtectionIfAlone() {
   if (busy) return;
   const button = document.querySelector('.sp-toggle');
   if (!button) return;
   if (button.getAttribute('aria-checked') !== 'true') return;
   const lineKey = button.dataset.lineKey;
   if (!lineKey) return;
   const variantId = parseInt(button.dataset.variantId, 10);


   let cart;
   try {
     const res = await fetch(`${ROOT}cart.js`, { headers: { 'Accept': 'application/json' } });
     if (!res.ok) return;
     cart = await res.json();
   } catch (err) {
     console.error('[sp-toggle] cart fetch failed', err);
     return;
   }


   if (cart.items.length === 0) return;
   const others = cart.items.filter((it) => it.variant_id !== variantId);
   if (others.length > 0) return; // there are still real products


   // Only protection remains — pull it out. Do NOT set sp_user_removed,
   // because the user didn't opt out; they emptied their cart.
   busy = true;
   try {
     const res = await fetch(`${ROOT}cart/change.js`, {
       method: 'POST',
       headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
       body: JSON.stringify({
         id: lineKey,
         quantity: 0,
         sections: SECTIONS.join(','),
         sections_url: window.location.pathname,
       }),
     });
     if (res.ok) {
       renderSections((await res.json()).sections);
     }
   } catch (err) {
     console.error('[sp-toggle] auto-remove failed', err);
   } finally {
     busy = false;
   }
 }


 function renderSections(sections) {
   if (!sections) return;
   if (sections['cart-drawer']) {
     const parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
     const incoming = parsed.querySelector('cart-drawer');
     const current = document.querySelector('cart-drawer');
     if (incoming && current) {
       current.innerHTML = incoming.innerHTML;
       current.classList.toggle('is-empty', incoming.classList.contains('is-empty'));
        // the overlay was just replaced: re-attach Dawn's click-outside-to-close, as Dawn's own renderContents does
        const spOverlay = current.querySelector('#CartDrawer-Overlay');
        if (spOverlay && typeof current.close === 'function') spOverlay.addEventListener('click', current.close.bind(current));
     }
   }
   if (sections['cart-icon-bubble']) {
     const bubble = document.getElementById('cart-icon-bubble');
     if (bubble) {
       const parsed = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
       const incoming = parsed.querySelector('.shopify-section') || parsed.body.firstElementChild;
       bubble.innerHTML = incoming ? incoming.innerHTML : sections['cart-icon-bubble'];
     }
   }
 }


 // Toggle click
 document.addEventListener('click', (e) => {
   const btn = e.target.closest('.sp-toggle');
   if (!btn) return;
   e.preventDefault();
   toggle(btn);
 });


 document.addEventListener('DOMContentLoaded', () => {
   const drawer = document.querySelector('cart-drawer');
   if (!drawer) return;


   // Drawer open → auto-add protection (if appropriate)
   new MutationObserver(() => {
     if (drawer.classList.contains('active')) autoAdd();
   }).observe(drawer, { attributes: true, attributeFilter: ['class'] });


   // Drawer contents changed (remove, qty change, re-render) → check orphan state
   let timer = null;
   new MutationObserver(() => {
     if (busy) return;
     clearTimeout(timer);
     timer = setTimeout(removeProtectionIfAlone, 200);
   }).observe(drawer, { childList: true, subtree: true });


   // Belt-and-suspenders: handle the case where the cart already
   // contained only protection when the page loaded.
   setTimeout(removeProtectionIfAlone, 600);
 });
})();
